import { cloneDeep } from "lodash";
import {
  allowedTechOutProvinces,
  provinces as legitProvinces,
} from "common/constants/maps";
import { DeliveryOptionsEnum } from "common";
import { getDeliveryOptionViaKM } from "utils/cart";

export const getProvince = (googleMapGeoCode: google.maps.GeocoderResult) => {
  const clonedProvinces = cloneDeep(legitProvinces) || [];
  const clonedProvincesArrProvinces = clonedProvinces?.map((x) => x?.name);
  const provincesOnMap = googleMapGeoCode?.address_components
    ?.filter(
      // filter provinces
      (x) =>
        x?.types?.includes("administrative_area_level_2") ||
        x?.types?.includes("administrative_area_level_1")
    )
    ?.map((y) => y?.long_name?.toUpperCase()); // convert to uppercase

  let finalProvince = "";
  provincesOnMap?.forEach((provOnMap) => {
    if (!finalProvince) {
      const findProvince = clonedProvincesArrProvinces?.find(
        (prov) => prov === provOnMap
      );
      if (findProvince) {
        finalProvince = findProvince;
      } else if (!findProvince && provincesOnMap?.length > 0) {
        finalProvince = provincesOnMap[0];
      }
    }
  });
  return finalProvince;
};

export const isCountryPH = (googleMapGeoCode: google.maps.GeocoderResult) => {
  const filteredCountry = googleMapGeoCode?.address_components
    ?.filter((x) => x?.types?.includes("country"))
    ?.map((y) => y?.long_name);
  const hasPhilippines = filteredCountry?.find((x) => x === "Philippines");
  return hasPhilippines ? true : false;
};

export const filterGeoCodePHOnly = (
  geocoderResults: google.maps.GeocoderResult[]
) => {
  const resultsWithPh = geocoderResults?.filter((result) =>
    result?.formatted_address?.includes("Philippines")
  );
  return resultsWithPh;
};

/**
 * NOTE: Use mapRef?.getCenter()?.toJSON(); if you want more accurate lat lng
 *
 * @param googleMapGeoCode
 * @returns number
 */
export const getLatitude = (googleMapGeoCode: google.maps.GeocoderResult) => {
  return googleMapGeoCode?.geometry?.location?.toJSON()?.lat;
};

/**
 * NOTE: Use mapRef?.getCenter()?.toJSON(); if you want more accurate lat lng
 *
 * @param googleMapGeoCode
 * @returns number
 */
export const getLongitude = (googleMapGeoCode: google.maps.GeocoderResult) => {
  return googleMapGeoCode?.geometry?.location?.toJSON()?.lng;
};

// NOTE: Deprecated.
// export const getDeliveryOption = (provinceArg: string, km?: number) => {
//   // Means no delivery mode yet
//   if (!provinceArg) {
//     // This Should be impossible
//     return undefined;
//   }
//   const provinceCaps = provinceArg?.toUpperCase();
//   const isForTechOut = allowedTechOutProvinces?.includes(provinceCaps);

//   if (isForTechOut) {
//     return DeliveryOptionsEnum.techOut;
//   }
//   const deliveryBasedOnKm = getDeliveryOptionViaKM(km);
//   if (deliveryBasedOnKm) {
//     return deliveryBasedOnKm;
//   }
//   return DeliveryOptionsEnum.jnt;
// };
